import React from 'react';

export const IsSequelIcon: React.FC<{ size?: number }> = ({ size }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size ?? 22}
            height={size ?? 22}
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g fill="#fff" fillOpacity="1" stroke="none" strokeWidth="2">
                <path
                    d="M10.95 8A3 3 0 008 11a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3 3 3 0 00-.05 0zM11 9.5a1.5 1.5 0 011.5 1.5 1.5 1.5 0 01-1.5 1.5A1.5 1.5 0 019.5 11 1.5 1.5 0 0111 9.5z"
                    transform="scale(.26458)"
                ></path>
                <path
                    d="M10.98 5a6 6 0 00-.617.033l.158 1.492A4.5 4.5 0 0111 6.5a4.5 4.5 0 014.488 4.178l1.496-.108a6 6 0 00-2.134-4.174A6 6 0 0010.98 5z"
                    transform="scale(.26458)"
                ></path>
                <path
                    d="M6.932 12.922l-1.358.64a6 6 0 003.852 3.227l.394-1.447a4.5 4.5 0 01-2.888-2.42z"
                    transform="scale(.26458)"
                ></path>
                <path
                    d="M10.99 2A9 9 0 002 11a9 9 0 009 9 9 9 0 009-9 9 9 0 00-9-9 9 9 0 00-.01 0zm-.027 1.5a7.5 7.5 0 01.037 0 7.5 7.5 0 017.5 7.5 7.5 7.5 0 01-7.5 7.5A7.5 7.5 0 013.5 11a7.5 7.5 0 017.463-7.5z"
                    transform="scale(.26458)"
                ></path>
            </g>
        </svg>
    );
};
